var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { id: "dashboard" },
    },
    [
      _c(
        "el-container",
        { staticStyle: { "max-width": "600px" } },
        [
          _c("el-input", {
            attrs: { placeholder: "Search text" },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", type: "primary" },
              on: { click: _vm.loadData },
            },
            [_vm._v("Search")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            "default-sort": { prop: "id", order: "descending" },
            data: _vm.tableData,
            stripe: "",
          },
          on: { "sort-change": _vm.handleSortChange },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "70", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "E-mail", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 20, 30, 40],
          layout: "sizes, prev, pager, next, total",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }